<template>
  <div class="home">
  
    <Reproductor msg="Los saludos" audio2="../mp3/PrimariaA/02PA.mp3" cover="../img/1.jpg" name="Primaria A - Lección #2"/>
    <Buttons/>
  </div>
</template>

<script>
// @ is an alias to /src

import Buttons from '@/components/Buttons.vue'
import Reproductor from '@/components/Reproductor.vue'
export default {
  name: 'LeccionA2',

  components: {
    Reproductor,
    Buttons,
    
  }
}
</script>
